import classes from './GetInTouchBox.module.css'
import SendMailComponentBlank from './SendMailComponentBlank'
import SendSmsComponentBlank from './SendSmsComponentBlank'

const GetInTouchBox = ({goto, type, data, boxType}) => {
    return <>
        {boxType== 'tel' && <a href={`${type}:${goto}`} className={classes.item}>
            <span className={classes.icon}>
                <i className='ti ti-phone'></i>
            </span>
        </a>}
   
        {boxType== 'sms' && <SendSmsComponentBlank phone={goto} type={type} data={data}>
            <div className={classes.item}>
                <span className={classes.icon}>
                    <i className='ti ti-device-mobile-message'></i>
                </span>
            </div>    
        </SendSmsComponentBlank>}
        {boxType== 'mailto' && <SendMailComponentBlank mail={goto} type={type} data={data}>
            <div className={classes.item}>
            <span className={classes.icon}>
                <i className='ti ti-mail'></i>
            </span>
        </div>
        </SendMailComponentBlank>}
    </>
}

export default GetInTouchBox